import createPersistedState from "vuex-persistedstate"

export const persist = createPersistedState({
  paths: ['global']
})
